import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

/**
 * Component to handle Supabase auth redirects that land on wrong routes
 * If there's an auth token in the hash on any route, redirect to /auth/callback
 */
const AuthRedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if there's an auth token in the hash
    const hash = window.location.hash;
    if (
      hash &&
      (hash.includes("access_token") ||
        hash.includes("type=magiclink") ||
        hash.includes("type=signup"))
    ) {
      // If we're not already on /auth/callback, redirect there with the hash
      if (location.pathname !== "/auth/callback") {
        navigate(`/auth/callback${hash}`, { replace: true });
      }
    }
  }, [location.pathname, navigate]);

  return null; // This component doesn't render anything
};

export default AuthRedirectHandler;
